module.exports = __webpack_public_path__ + "static/media/OCO.23b5a54f.png";